import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";

var Material = function Material() {
  _classCallCheck(this, Material);
};

export { Material as default };
//# sourceMappingURL=material.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@luma.gl/core/dist/esm/materials/material.js
// module id = 385
// module chunks = 0